import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import {
  useDetalheEnvioGateway,
  useXmlEnviadoGateway
} from "../../api/ESocialJTServiceApi";
import DataPanel from "../../components/data/DataPanel";
import LabelEstado from "../../components/estado/LabelEstado";
import JsonPanel from "../../components/json-panel/JsonPanel";
import Page from "../../components/layout/page/Page";
import PageHeader from "../../components/page-header/PageHeader";
import Voltar from "../../components/voltar/Voltar";
import XmlEnviadoPanel from "../../components/xml-envio/XmlEnviadoPanel";
import { formataDataTempoLong } from "../../shared/dataUtil";
import { estadoVisualEnvio, tituloEnvio } from "../../shared/envioGatewayUtil";

function EventoDetalhePage() {
  const { id } = useParams();
  const { data: envio = {}, isLoading } = useDetalheEnvioGateway(id);
  const { data: xmlEnviado = "", isLoading: xmlLoading } =
    useXmlEnviadoGateway(id);

  const dadosEnvio = {
    id: envio.id,
    externalId: envio.externalId,
    tenant: envio.tenant,
    idXml: envio.idXml,
    empresaDocumento: envio.empresaDocumento,
    ambiente: envio.ambiente,
    tipoEvento: envio.tipoEvento,
    grupo: envio.grupo,
    empregador: envio.empregador,
    estado: envio.estado,
    protocolo: envio.protocolo,
    recibo: envio.recibo,
    codigo: envio.codigo,
    descricao: envio.descricao,
    tentativasTecnicas: envio.tentativasTecnicas,
    criadoEm: envio.criadoEm,
    atualizadoEm: envio.atualizadoEm,
    finalizadoEm: envio.finalizadoEm
  };

  return (
    <Page>
      <DataPanel loading={isLoading}>
        <PageHeader
          primary={tituloEnvio(envio)}
          secondary={
            envio.criadoEm
              ? `ID: ${id} | Enviado em ${formataDataTempoLong(envio.criadoEm)}`
              : `ID: ${id}`
          }
          commands={[
            <LabelEstado estado={estadoVisualEnvio(envio.estado)} />,
            <Voltar />
          ]}
        />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <JsonPanel
              primary="Dados do envio"
              secondary="Dados operacionais persistidos no Gateway eSocial"
              src={dadosEnvio}
            />
          </Grid>
          <Grid item xs={12}>
            <XmlEnviadoPanel
              xml={xmlEnviado}
              loading={xmlLoading}
              nomeArquivo={`${envio.idXml || envio.id || "evento"}.xml`}
            />
          </Grid>
          <Grid item xs={12}>
            <JsonPanel
              primary="Ocorrências"
              secondary="Retornos, rejeições e mensagens técnicas do processamento"
              src={envio.ocorrencias || []}
              collapsed={!envio.ocorrencias?.length}
            />
          </Grid>
        </Grid>
      </DataPanel>
    </Page>
  );
}

export default EventoDetalhePage;
